// Keep the full-size lid photo below the currently selected mug on desktop.
document.addEventListener('slideshow:select', (event) => {
  const gallery = event.target.closest('media-gallery');
  const panel = gallery?.querySelector('.kofea-lid-gallery');
  if (!panel) return;
  const mediaId = event.detail.slide.querySelector('.product-media')?.dataset.mediaId;
  let active = false;
  panel.querySelectorAll('.kofea-lid-gallery__item').forEach((item) => {
    item.hidden = item.dataset.mediaId !== mediaId;
    if (!item.hidden) active = true;
  });
  panel.hidden = !active;
});
